module.exports = __webpack_public_path__ + "img/241.6ce55a2e.jpg";